module.exports = __webpack_public_path__ + "img/research-group-9.0ee2fd96.jpg";